import React, {Component} from 'react';
import {connect} from 'react-redux'
import {locale} from '../../locale/AppLocale'
import Loader from "../../Components/Loader";
import axios from 'axios';
import {NotificationManager} from '../../Helpers/NotificationManager';;
import Config from "../../Helpers/Config";

class Transactions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
            ready: false,
            transactions: [],
        };

        this.init = this.init.bind(this);
        this.createMarkup = this.createMarkup.bind(this);
        this.renderItems = this.renderItems.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    init() {
        this.setState({
            fetching: true
        }, () => {
            const data = {};

            axios.post(`${Config.api()}financial/account-summary/transactions/${this.props.auth.business.id}`, data, {
                withCredentials: Config.withCredentials()
            }).then((response) => {
                if (response.data.status) {
                    this.setState({
                        fetching: false,
                        ready: true,
                        transactions: response.data.transactions,
                    });
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                }
            });
        });
    }

    createMarkup(string) {
        return {__html: string};
    }

    render() {
        return (
            this.state.fetching && !this.state.ready ? <Loader completed={this.state.ready}/> : <div>
                <div className="panel-1">
                    <div className="panel-1--head bg-white">
                        {locale.get('financial_transactions')}
                    </div>
                    <div className="panel-1--body is-full">
                        {this.renderItems()}
                    </div>
                </div>
            </div>

        )
    }

    renderItems() {
        return (
            this.state.transactions.length === 0 ? <div>{locale.get('no_transactions_found')}</div> : <div>
                <table className="table ">
                    <thead>
                    <tr>
                        <th colSpan={2}>#</th>
                        <th>{locale.get('business_name')}</th>
                        <th>{locale.get('status')}</th>
                        <th>{locale.get('payment_way')}</th>
                        <th>{locale.get('credit')}</th>
                        <th>{locale.get('debit')}</th>
                        <th>{locale.get('notes')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.transactions.map((transaction, index) => {
                        return <tr key={`row-${index}`}>
                            <td>{transaction.id}</td>
                            <td>{transaction.request_id}</td>
                            <td>{transaction.business.name_ar}</td>
                            <td>{transaction.status_text}</td>
                            <td>{transaction.payment_way_text}</td>
                            <td className="price" dangerouslySetInnerHTML={this.createMarkup(transaction.credit_formatted)}/>
                            <td className="price" dangerouslySetInnerHTML={this.createMarkup(transaction.debit_formatted)}/>
                            <td>{transaction.notes}</td>

                        </tr>
                    })}
                    </tbody>
                </table>
            </div>
        )
    }

}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);
